export const PAYMENT_STATUS_COLOR = {
	unpaid: "#E2E2E2",
	pending: "#F2B821",
	declined: "#F43F5E",
	paid: "#45C14A",
	approved: "#7DD3FC",
};
